import { notifyAuthStateChanged } from '@shared/utils/authState';

let refreshPromise: Promise<boolean> | null = null;

/**
 * 서버사이드 API(/api/auth/refresh)를 통해 refreshToken으로 accessToken을 갱신합니다.
 * 동시 호출 시 하나의 요청만 실행되고 결과를 공유합니다.
 *
 * 성공/실패 모두 인증 쿠키가 교체되거나 삭제되므로 구독자에게 알린다.
 * (네트워크 오류로 BFF 에 닿지 못한 경우는 쿠키가 그대로라 알림 대상이 아니다.)
 */
export async function refreshAccessToken(): Promise<boolean> {
  if (refreshPromise) return refreshPromise;

  refreshPromise = fetch('/api/auth/refresh', { method: 'POST' })
    .then((res) => {
      notifyAuthStateChanged();
      return res.ok;
    })
    .catch(() => false)
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}
